import { useEffect } from 'react';
import PropTypes from 'prop-types';
import LoadingScreen from 'src/components/LoadingScreen';

const CrossAppRedirect = ({ route }) => {
  useEffect(() => {
    if (route?.externalUrl) {
      window.location.replace(route.externalUrl);
    }
  }, [route?.externalUrl]);

  return <LoadingScreen />;
};

CrossAppRedirect.propTypes = {
  route: PropTypes.shape({
    externalUrl: PropTypes.string,
  }),
};

export default CrossAppRedirect;
